import React from 'react';
import PropTypes from 'prop-types';

const AnalysisForm = ({ url, setUrl, isLoading, onSubmit }) => {
    return (
        <div className="analysis-form">
            <form onSubmit={onSubmit}>
                <div className="input-group">
                    <input
                        type="url"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        placeholder="https://example.com"
                        required
                        disabled={isLoading}
                        className="url-input"
                    />
                    <button
                        type="submit"
                        disabled={isLoading || !url.trim()}
                        className="analyze-btn"
                    >
                        {isLoading ? (
                            <>
                                Analyzing...
                            </>
                        ) : (
                            'Analyze Website'
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

AnalysisForm.propTypes = {
    url: PropTypes.string.isRequired,
    setUrl: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default AnalysisForm;
